import React, { useEffect, useMemo, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useTable,
  useSortBy,
} from "react-table";
import { useDispatch, useSelector } from "react-redux";
import {
  pageSelector,
  pageSizeSelector,
  updatePage,
  updatePageSize,
} from "../../redux/surveySlice";
import NoTemplateAdded from "../admin-component/templates/NoTemplateAdded";
import Selectable from "../Form/Selectable";
function Table({
  totalCount,
  getData,
  headers,
  isSearchAble,
  gridData,
  searchText,
  selected,
  content,
  addNew,
  onAdd,
}) {
  const isMounted = useRef();
  const searchTimeout = useRef();
  const dispatch = useDispatch();
  const pageSize = useSelector(pageSizeSelector);
  const pageNumber = useSelector(pageSelector);
  var totalPages = totalCount > 1 ? Math.ceil(totalCount / pageSize) : 1;
  const data = useMemo(() => gridData, [gridData]);
  const columns = React.useMemo(() => headers, [headers]);
  let pageIn = useRef();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    setPageSize,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 20, pageNumber: pageNumber },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  pageIn.current = pageIndex;

  const increment = () => {
    getData(pageSize, pageNumber + 1);
  };

  const decrement = () => {
    getData(pageSize, pageNumber - 1);
  };

  const handlePageSize = (e) => {
    setPageSize(e);
    dispatch(updatePageSize(e));
    getData(e, 1);
  };

  useEffect(() => {
    if (isMounted.current && isSearchAble) {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }

      searchTimeout.current = setTimeout(() => {
        getData(pageSize, 1);
        dispatch(updatePage(1));
      }, 500);
    }
    isMounted.current = true;
  }, [searchText]);

  return (
    <>
      {gridData.length > 0 ? (
        <div className="table-responsive">
          <table className="table" {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column, idx) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      key={`column_${idx}_header`}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <tr
                    className={row?.original?.checked ? "active" : ""}
                    {...row.getRowProps()}
                  >
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <span className="d-flex align-items-center mb-3 justify-content-center">
          <NoTemplateAdded
            selected={searchText ? "No search result found" : selected}
            content={searchText ? "Try searching something else" : content}
            addNew={addNew}
            onAdd={onAdd}
          />
        </span>
      )}
      <nav className="pagination-wrapper d-flex justify-content-end">
        {totalPages > 1 && (
          <>
            <ul className="pagination align-items-center mt-0">
              <li className="page-item">
                <p>
                  Page
                  {"  " + pageNumber} of {totalPages}
                </p>
              </li>
              <li>
                <Selectable
                  disableClear={true}
                  options={[
                    { label: 20, value: 20 },
                    { label: 50, value: 50 },
                    { label: 100, value: 100 },
                  ]}
                  value={pageSize}
                  onChange={(e) => handlePageSize(e)}
                />
              </li>
              <li className={`page-item`}>
                <button
                  className="page-link"
                  onClick={() => decrement()}
                  disabled={pageNumber === 1}
                  tabIndex={-1}
                >
                  <i>
                    <Icon icon="ic:round-keyboard-arrow-left" />
                  </i>{" "}
                </button>
              </li>

              <li className={`page-item`}>
                <button
                  className="page-link"
                  onClick={() => increment()}
                  disabled={pageNumber === totalPages}
                >
                  <i>
                    <Icon icon="ic:round-keyboard-arrow-right" />
                  </i>
                </button>
              </li>
            </ul>
          </>
        )}
      </nav>
    </>
  );
}

export default Table;
